export const config = { version: 1, maxAge: Infinity };

export const actionMap = {
  "@@auth/AUTH_SET": ["auth"],
  "@@profile/PROFILE_SET": ["profile"],
  "@@content/CONTENT_SET": ["content"],
  "@@content/CONTENT_API_SET": ["contentApiData"],
};
